// frontend/src/shared/theme/shadows.js

const shadows = {
  card: "0 4px 14px rgba(40, 24, 82, 0.14)",
  soft: "0 2px 10px rgba(88, 70, 144, 0.08)",
  hover: "0 8px 24px rgba(40, 24, 82, 0.16)",
};

export default shadows;